import {IconProps} from "./types";

export const DistanceIcon = ({fill}: IconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM9.90234 3.25C11.4419 3.25 12.7549 4.44647 12.7549 6C12.7549 7.55353 11.4419 8.75 9.90234 8.75H6.10742C5.32511 8.75006 4.75488 9.34443 4.75488 10C4.75488 10.6556 5.32511 11.2499 6.10742 11.25H9.00488V12.75H6.10742C4.56793 12.7499 3.25488 11.5535 3.25488 10C3.25488 8.47949 4.51285 7.30332 6.00977 7.25391V7.25H9.90234C10.6847 7.25 11.2549 6.65561 11.2549 6C11.2549 5.34439 10.6847 4.75 9.90234 4.75H7.00488V3.25H9.90234ZM4 2C5.10457 2 6 2.89543 6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2Z"
        fill={fill || "#6B7280"}
      />
    </svg>
  );
};
